import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from '../Actions/userActions';
import UserForm from "../Components/User/UserForm";
//import { customerService } from "../Services/CustomerService.js";
import { userService } from "../Services/UserService.js";
//import { curriculumService } from "../Services/CurriculumService.js";
import { languageService } from "../Services/LanguageService.js";
import { withRouter } from 'react-router';
import {denormalizerService} from "../Services/denormalizerService.js";

class UserFormContainer extends Component {
	constructor(props) {
		super(props);
		this.state={
			langPairs: [],
		};
		this.saveUser = this.saveUser.bind(this);
	}
	
	componentDidMount() {
		languageService.getLangiuagePairs()
			.then(response => {let list=response.data; return this.setState({ langPairs: list.sort(function(a, b) { return (a.code > b.code) ? 1 : ((a.code < b.code) ? -1 : 0);}) });;})
			//.then( response => this.setState({curriculum: response.data }))
			.catch(err => {/*console.log(err);*/});
	}
	
	saveUser(user, password){
		let denormlaizedUser = denormalizerService.userDenormalizer(user);
		
		if(this.props.user.role!=="ADMIN"){
			if(password && password.length>3){
				userService.updateUserPassword(user.id, password)
					.then(response => {return this.props.history.go(-1);})
					.catch(err => {/*console.log(err);*/});
			}
		}else{
			userService.updateUser(denormlaizedUser)
				.then(response => { 
					if(password && password.length>3){
						return userService.updateUserPassword(response.data.id, password);
					}else{
						return 1;
					}
				})
				.then(response => {return this.props.history.go(-1);})
				.catch(err => {/*console.log(err);*/});
		}
	}
	
	render() {
//		console.log(this.props);
		var user;
		let newDate = new Date();
		if(this.props.userRecord!==undefined){
			user = this.props.userRecord;
		}else{
			user = {
				id: 0,
				username: "",
				firstName: "",
				lastName: "",
				enabled: true,
				//customer: this.props.customer,
				customer: this.props.customerId,
				role: "CUSTOMER",
				idOdoo: 0
			}
		}
		if(this.props.user.role!=="ADMIN" && this.props.user.id!=user.id){
			return this.props.history.go(-1);
		}else{
			return (<UserForm	user={user}
							loggedUser={this.props.user}
							customerId={this.props.customerId}
							customers={this.props.customers}
							langPairs={this.state.langPairs}
							saveUser={this.saveUser}
							usersList={this.props.usersList}
				/>);
		}
	}
}

function mapStateToProps(state, ownProps) {  
//	console.log('mapStateToProps [UserFormContainer]: '+JSON.stringify(ownProps));
	return {
		userRecord: state.users[ownProps.match.params.id],
		usersList: state.users,
		customers: state.customers,
		customerId: ownProps.match.params.customerId,
		user: state.user
	}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(userActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserFormContainer);  